var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Input as ThemeUIInput, } from 'theme-ui';
import { useTheme } from '../../../theme';
const getDefaultStyles = (theme) => ({
    height: 40,
    border: 1,
    borderRadius: 'regular',
    borderStyle: 'solid',
    borderColor: 'neutralBorderWeakDisabled',
    margin: 0,
    px: 14,
    py: 5,
    backgroundColor: 'neutralBgMedium',
    '&:focus': {
        borderColor: theme.colors.baseBorder,
        caretColor: theme.colors.baseText,
    },
});
const Input = forwardRef((_a, ref) => {
    var { children, sx } = _a, props = __rest(_a, ["children", "sx"]);
    const { theme } = useTheme();
    return (_jsx(ThemeUIInput, Object.assign({ ref: ref, sx: Object.assign(Object.assign({}, getDefaultStyles(theme)), sx) }, props, { children: children })));
});
export default Input;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5wdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb21tb25zL0lucHV0L0lucHV0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBQ25DLE9BQU8sRUFFTCxLQUFLLElBQUksWUFBWSxHQUd0QixNQUFNLFVBQVUsQ0FBQztBQUVsQixPQUFPLEVBQWEsUUFBUSxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUFFckQsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLEtBQWdCLEVBQXNCLEVBQUUsQ0FBQyxDQUFDO0lBQ2xFLE1BQU0sRUFBRSxFQUFFO0lBQ1YsTUFBTSxFQUFFLENBQUM7SUFDVCxZQUFZLEVBQUUsU0FBUztJQUN2QixXQUFXLEVBQUUsT0FBTztJQUNwQixXQUFXLEVBQUUsMkJBQTJCO0lBQ3hDLE1BQU0sRUFBRSxDQUFDO0lBQ1QsRUFBRSxFQUFFLEVBQUU7SUFDTixFQUFFLEVBQUUsQ0FBQztJQUNMLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsU0FBUyxFQUFFO1FBQ1QsV0FBVyxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsVUFBVTtRQUNwQyxVQUFVLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxRQUFRO0tBQ2xDO0NBQ0YsQ0FBQyxDQUFDO0FBRUgsTUFBTSxLQUFLLEdBQTZDLFVBQVUsQ0FDaEUsQ0FBQyxFQUEwQixFQUFFLEdBQUcsRUFBRSxFQUFFO1FBQW5DLEVBQUUsUUFBUSxFQUFFLEVBQUUsT0FBWSxFQUFQLEtBQUssY0FBeEIsa0JBQTBCLENBQUY7SUFDdkIsTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLFFBQVEsRUFBRSxDQUFDO0lBRTdCLE9BQU8sQ0FDTCxLQUFDLFlBQVksa0JBQ1gsR0FBRyxFQUFFLEdBQUcsRUFDUixFQUFFLGtDQUFPLGdCQUFnQixDQUFDLEtBQUssQ0FBQyxHQUFLLEVBQUUsS0FDbkMsS0FBSyxjQUVSLFFBQVEsSUFDSSxDQUNoQixDQUFDO0FBQ0osQ0FBQyxDQUNGLENBQUM7QUFFRixlQUFlLEtBQUssQ0FBQyJ9